@if (anchor) {
  <a [id]="anchor"></a>
}
<kb-accordion>
  @for (item of attributes.items; track item) {
    <kb-accordion-panel
      [headingLevel]="3"
      [appEditorId]="item.editorId"
    >
      <kb-panel-header [appTrackClick]="'Tab:' + item.attributes.headline" [appEditorId]="item.editorIds?.headline">{{item.attributes.headline}}</kb-panel-header>
      <kb-panel-content>
        @if (isLegacyAccordionItemAttributes(item.attributes)) {
          <ng-template #mediumTemplate>
            @if (isPlainImageSection(item.attributes.medium!)) {
              <app-plain-image [section]="item.attributes.medium"></app-plain-image>
            }
            @if (isVideoSection(item.attributes.medium!)) {
              <app-plain-video [section]="item.attributes.medium" controls="full"></app-plain-video>
            }
            @if (isInteractiveImageSection(item.attributes.medium!)) {
              <app-interactive-image [attributes]="item.attributes.medium.attributes" [editorIds]="item.attributes.medium.editorIds" [appendTo]="hostElement"></app-interactive-image>
            }
          </ng-template>
          @if (item.attributes.medium && item.attributes.mediumPosition === 'top') {
            <ng-template [ngTemplateOutlet]="mediumTemplate"></ng-template>
          }
          <kb-card>
            <div slot="content" [appEditorId]="item.editorIds?.content" kb-html [html]="item.attributes.content"></div>
          </kb-card>
          @if (item.attributes.medium && item.attributes.mediumPosition === 'bottom') {
            <ng-template [ngTemplateOutlet]="mediumTemplate"></ng-template>
          }
        } @else {
          @let firstSectionType = item.attributes.sections[0].component;
          @let lastSectionType = item.attributes.sections[item.attributes.sections.length - 1].component;
          <div
            [appEditorId]="item.editorId"
            kb-layout="grid"
            [class.starting-gap]="firstSectionType !== 'medium' && firstSectionType !== 'interactive-image'"
            [class.ending-gap]="lastSectionType !== 'medium' && lastSectionType !== 'interactive-image'"
          >
            @for (section of item.attributes.sections; track section) {
              @if (isCopyTextSection(section)) {
                <app-copy-text [attributes]="section.attributes" [appEditorId]="section.editorId" [editorIds]="section.editorIds"/>
              } @else if (isMediumSection(section)) {
                <app-medium [attributes]="section.attributes" [appEditorId]="section.editorId" [editorIds]="section.editorIds"/>
              } @else if (isDownloadList(section)) {
                <app-download-list [attributes]="section.attributes" [appEditorId]="section.editorId" [editorIds]="section.editorIds"/>
              } @else if (isInteractiveImageSection(section)) {
                <app-interactive-image [attributes]="section.attributes" [appEditorId]="section.editorId" [editorIds]="section.editorIds" [appendTo]="hostElement"/>
              } @else if (isDomTableSection(section)) {
                <section app-dom-table [attributes]="section.attributes" [appEditorId]="section.editorId" [editorIds]="section.editorIds"></section>
              }
            }
          </div>
        }
      </kb-panel-content>
    </kb-accordion-panel>
  }
</kb-accordion>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
